define({
    NAV:{
        LANDING: 'landingPage',
        CONV_BUILDER: 'conversationBuilder',
        BOT_PLATFORM: 'botPlatform'
    },
    NAMESPACES:{
        CONVERATION_BUILDER: 'conversationbuilder',
        BOT_PLATFORM: 'botplatform'
    },
    ROUTES:{
        CONVERATION_BUILDER: 'conversation',
        BOT_PLATFORM: 'botplatform',
        LANDING_PAGE: 'landing-page'
    }
});
